import React, { useEffect, useState } from "react";
import ManageOder from "../ManageOrders/ManageOrder";
const ManageOrders = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    fetch("https://ancient-harbor-24674.herokuapp.com/orders")
      .then((res) => res.json())
      .then((data) => setOrders(data));
  }, []);
  return (
    <div className="m-5 p-3 container m-auto mt-5">
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <h1 className="">Our offering's tour</h1>
            <span>
              <hr className="w-25 m-auto mb-2" />
            </span>
            {orders.map((order) => (
              <ManageOder key={order.id} order={order}></ManageOder>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageOrders;
